'use strict'

import Route from './route.js';
import RouteMarker from '../markers/route-marker.js';


export default class TripsRoute extends Route {
    constructor(fullRouteInfo, map) {
        super(fullRouteInfo.track, map, undefined, undefined, undefined, undefined, fullRouteInfo);
    }

    _createLayer() {
        let multiOptions = this._makeMultiOptionsObject();
        let colorPolyline = L.multiOptionsPolyline(this.coordsArray, {
            multiOptions: multiOptions,
            weight: this.config.routeLine.width,
            lineCap: 'round',
            interactive: false,
            opacity: 1,
            smoothFactor: 1
        });

        return colorPolyline;
    };

    _fillTripEndTimes(fullRouteInfo) {
        this.tripsEndTimes = [];

        if (fullRouteInfo.stops.stops.length == 0)
            return;

        var firstStopEndTime = this._getEndTimeOfStop(fullRouteInfo.stops.stops[0].stop_time, fullRouteInfo.stops.stops[0].duration);

        // если трек начинается не со стоянки, а с движения - значит, надо время конца первой стоянки добавлять в цветовой диапазон
        if (new Date(fullRouteInfo.track.coords[0].tm) < firstStopEndTime) {
            this.tripsEndTimes.push(firstStopEndTime);
        }

        for (var i = 1; i < fullRouteInfo.stops.stops.length; i++) {
            this.tripsEndTimes.push(this._getEndTimeOfStop(fullRouteInfo.stops.stops[i].stop_time, fullRouteInfo.stops.stops[i].duration));
        }
    };

    _fillTripsColors(routesColors) {
        this.tripsColors = [];

        if (this.tripsEndTimes == undefined)
            this._fillTripEndTimes(this.fullRouteInfo);

        for (var i = 0; i < this.tripsEndTimes.length; i++) {
            var colorIndex = i % this.routesColors.length;

            this.tripsColors.push({ color: routesColors[colorIndex] });
        }
    };

    _getEndTimeOfStop(startTime, duration) {
        var time = new Date(startTime);
        time.setSeconds(time.getSeconds() + duration);

        return time;
    };

    _getColorIndex(pointTime) {
        for (var i = 0; i < this.tripsEndTimes.length; i++) {
            if (pointTime <= this.tripsEndTimes[i]) {
                return i;
            }
        }
        return this.tripsEndTimes.length - 1;
    };

    _makeMultiOptionsObject() {

        if (this.tripsColors == undefined)
            this._fillTripsColors(this.routesColors);

        let multiopts = {
            optionIdxFn: (latLng) => {

                return this._getColorIndex(latLng[2]);

            },
            options: this.tripsColors
        };
        return multiopts;
    };

    _createRouteMarker(point) {
        if (this.tripsColors == undefined)
            this._fillTripsColors(this.routesColors);

        var colorIndex = this._getColorIndex(new Date(point.tm));

        return new RouteMarker(this.map, point, this.route.oid, this.allDistance, this.tripsColors[colorIndex].color);
    }

    _fillCoordsArray(point) {
        this.coordsArray.push([point.lat, point.lon, new Date(point.tm)]);
    };

    reduceIndex(index) {
        return index;
    }
}
